<template>
  <div class="my-3">
    <div class="font-medium font-weight-bold">
      Print on Demand
    </div>

    <base-loader v-if="isLoading" />

    <template v-if="!isLoading">
      <div
        class="d-flex align-center py-3"
        style="gap: 16px"
      >
        <div>
          <div class="font-weight-bold font-small">
            Label
          </div>
          <div>
            {{ printOnDemandTitleOverride }} <span
              v-if="printOnDemandTitleOverride === 'Available at other Retailers'"
              class="font-small"
            >(default)</span>
          </div>
        </div>
        <div>
          <v-btn
            icon
            color="primary"
            @click="openTitleDialog()"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <div class="font-small gray--text">
            override
          </div>
        </div>
      </div>

      <v-chip
        class="mt-2 ml-2 clickable"
        @click="createDialog()"
      >
        Add Print on Demand Links

        <v-avatar right>
          <v-icon>mdi-plus</v-icon>
        </v-avatar>
      </v-chip>

      <div
        v-for="printOnDemand in printOnDemands"
        :key="printOnDemand.id"
        class="d-flex py-3 row"
        style="gap: 24px"
        role="button"
        @click="updateDialog(printOnDemand)"
      >
        <div>
          <div class="font-weight-bold font-small">
            Label
          </div>
          <div>{{ printOnDemand.label }}</div>
        </div>

        <div style="flex: 1; overflow: hidden; max-height: 60px">
          <div class="font-weight-bold font-small">
            Link
          </div>
          <div>
            {{ printOnDemand.printOnDemandLink }}
          </div>
        </div>

        <div style="flex: 1; overflow: hidden">
          <div class="font-weight-bold font-small">
            ISBN
          </div>
          <div>
            {{ printOnDemand.printOnDemandSku }}
          </div>
        </div>

        <button
          class="end"
          style="justify-self: end"
          aria-label="delete"
          @click="deletePrintOnDemand($event, printOnDemand)"
        >
          <v-icon>mdi-close</v-icon>
        </button>
      </div>
    </template>

    <v-dialog
      v-model="titleDialog"
      persistent
    >
      <v-card>
        <v-card-title class="bpg-card-title-block d-flex justify-space-between">
          <div class="font-weight-extra">
            Override Print on Demand Title
          </div>

          <v-btn
            icon
            aria-label="close"
            @click="titleDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="pa-6">
          <base-input
            v-model="titleOverrideCopy"
            label="Title"
            placeholder="Available at other Retailers"
          />
        </div>

        <div class="d-flex pa-6 stripe">
          <v-btn
            text
            @click="titleDialog = false"
          >
            <span
              style="font-weight: 600"
              class="primary--text"
            > CANCEL</span>
          </v-btn>

          <div style="flex: 1" />

          <base-button
            text="Save"
            @click="saveTitle()"
          />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      persistent
    >
      <v-card>
        <v-card-title class="bpg-card-title-block d-flex justify-space-between">
          <div class="font-weight-extra">
            Print on Demand
          </div>

          <v-btn
            icon
            aria-label="close"
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="pa-6 font-default-size">
          <base-input
            v-model="copy.printOnDemandSku"
            label="ISBN"
            :required="true"
            class="mb-3"
          />

          <base-input
            v-model="copy.label"
            label="Label"
            :required="true"
            class="mb-3"
          />

          <base-input
            v-model="copy.printOnDemandLink"
            label="Url (https)"
            :required="true"
            class="mb-3"
          />
        </div>

        <div class="d-flex pa-6 stripe">
          <v-btn
            text
            @click="closeDialog()"
          >
            <span
              style="font-weight: 600"
              class="primary--text"
            > CANCEL</span>
          </v-btn>

          <div style="flex: 1" />

          <base-button
            text="Save"
            :disabled="invalid"
            @click="createOrUpdate()"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ProductPrintOnDemand",
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    printOnDemands: {
      type: Array,
      required: true
    },
    printOnDemandTitleOverride: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    titleDialog: false,
    copy: {
      isAvailable: true,
      printOnDemandSku: "",
      printOnDemandLink: "",
      label: ""
    },
    titleOverrideCopy: ''
  }),
  computed: {
    invalid () {
      return (
        !this.copy.label ||
        !this.copy.printOnDemandSku ||
        !this.copy.printOnDemandLink
      )
    }
  },
  methods: {
    openTitleDialog () {
      console.log('what is this', this.printOnDemandTitleOverride)
      this.titleOverrideCopy = this.printOnDemandTitleOverride
      this.titleDialog = true
    },
    openDialog () {
      this.dialog = true
    },
    createOrUpdate () {
      this.dialog = false
      this.$emit("createOrUpdate", this.copy)
    },
    createDialog () {
      this.copy = {
        isAvailable: true,
        printOnDemandSku: "",
        printOnDemandLink: "",
        label: ""
      }
      this.dialog = true
    },
    updateDialog (printOnDemand) {
      this.copy = { ...printOnDemand }
      this.dialog = true
    },
    deletePrintOnDemand (event, printOnDemand) {
      event.stopPropagation()
      this.$emit("deletePrintOnDemand", printOnDemand.id)
    },
    saveTitle () {
      this.$emit("saveTitle", this.titleOverrideCopy)
      this.titleDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/styles/variables";
.stripe {
  background-color: $even-lighter-grey;
}

.row:hover {
  background-color: $even-lighter-grey;
}
</style>
